// @flow
export const Activities = {
  Aquabike: 1,
  Aquagym: 2,
  Aquatonique: 3,
  Equilibre: 4,
  GymSante: 5,
  GymnastiqueActive: 6,
  GymnastiqueDouce: 7,
  MarcheActive: 8,
  MarcheNordique: 9,
  Prenatal: 10,
  RelaxationPosturale: 11,
  Stretching: 12,
  Autre: 13,
  GymVirtuelle: 14,
};
